import { supabase } from '../supabase';

/**
 * Returns true when a booking has been flagged "Remove from automations".
 *
 * Checked at execution time in every dispatch path so that even already-queued
 * jobs (e.g. a pending reminder) are suppressed when they run. Fails OPEN: if the
 * lookup errors, we return false so a transient DB hiccup never silently breaks
 * the core automation feature.
 */
export async function areBookingAutomationsDisabled(bookingId?: string | null): Promise<boolean> {
  if (!bookingId || !supabase) return false;
  try {
    const { data, error } = await supabase
      .from('bookings')
      .select('automations_disabled')
      .eq('id', bookingId)
      .maybeSingle();
    if (error) {
      console.warn('[automationGuard] Could not read automations_disabled, proceeding:', error.message);
      return false;
    }
    return data?.automations_disabled === true;
  } catch (e) {
    console.warn('[automationGuard] Unexpected error reading automations_disabled, proceeding:', e);
    return false;
  }
}
